export default __webpack_public_path__ + "static/media/s9.74a2e58e.jpg";